import CalendarEventsStoreIndex from './schema/CalendarEventsStoreIndex';
import { eventComparer } from '../utils/eventComparer';
import getCalendarEventKey from '../utils/getCalendarEventKey';
import CalendarEventKeyRange from './schema/CalendarEventKeyRange';
import expandCalendarEventIfSpilling from '../utils/expandCalendarEventIfSpilling';
import { CalendarEvent, CalendarEventKey } from 'mini-calendar-event-types';
import { SortedKeyMap } from 'mini-sortedkeymap/lib/SortedKeyMap';
import { measurePerf } from 'mini-performance/lib/utils/measurePerf';

export default class CalendarEventKeyIndex implements CalendarEventsStoreIndex {
    private eventsInSortedKeyMap: SortedKeyMap<CalendarEventKey, CalendarEvent>;

    constructor() {
        this.eventsInSortedKeyMap = new SortedKeyMap<CalendarEventKey, CalendarEvent>(
            eventComparer as (k1: CalendarEventKey, k2: CalendarEventKey) => -1 | 0 | 1,
            (key: CalendarEventKey) => key.itemId + key.timestamp
        );
    }

    getCalendarEvents(range: CalendarEventKeyRange): CalendarEvent[] {
        return measurePerf('SortedKeyMapGetRange', {
            size: this.eventsInSortedKeyMap.size,
        })(() =>
            this.eventsInSortedKeyMap
                .getRange(range.start, range.end, !!range.includeEnd /* include range.end */)
                .map(pair => pair[1])
        );
    }

    getCalendarEvent(key: CalendarEventKey): CalendarEvent {
        return measurePerf('SortedKeyMapGetSingleEvent')(() => this.eventsInSortedKeyMap.get(key));
    }

    onAddCalendarEvent(event: CalendarEvent): void {
        this.expandEvent(event).forEach(e => {
            measurePerf('AddInSortedKeyMap')(() => {
                this.eventsInSortedKeyMap.set(getCalendarEventKey(e), e);
            });
        });
    }

    onDeleteCalendarEvent(event: CalendarEvent): void {
        this.expandEvent(event).forEach(e => {
            measurePerf('DeleteInSortedKeyMap')(() => {
                this.eventsInSortedKeyMap.delete(getCalendarEventKey(e));
            });
        });
    }

    clearIndex() {
        this.eventsInSortedKeyMap.clear();
    }

    expandEvent(event: CalendarEvent): CalendarEvent[] {
        return expandCalendarEventIfSpilling(event);
    }
}
